import { getSettingOrSettingDefault } from '@disy/workbook.lib/settings';

import { getStore } from 'cadenza/store/cadenza-store';
import type { WorksheetDto } from 'cadenza/workbook/api/worksheet-dto';
import type { WorksheetId } from 'cadenza/workbook/api/worksheet-id';
import { WorksheetLinearLayoutViewOrder } from 'cadenza/workbook/model/worksheet-linear-layout-view-order.gen';
import { WorksheetSettingsKey } from 'cadenza/workbook/model/worksheet-settings-key.gen';
import { getWorksheetById } from 'cadenza/workbook/workbook-core-selectors.state';

const VIEW_ORDER_KEY = WorksheetSettingsKey.toPersistenceKey('LINEAR_LAYOUT_VIEW_ORDER');
const VIEW_ORDER_VALUE_MANUAL = WorksheetLinearLayoutViewOrder.toPersistenceKey('MANUAL');

export function areViewsOrderedAutomatically(worksheetId: WorksheetId) {
  const worksheet = getWorksheetById(getStore().getState(), worksheetId);
  return VIEW_ORDER_VALUE_MANUAL !== getViewOrderSetting(worksheet);
}

export function getViewOrderSetting(worksheet: WorksheetDto) {
  return getSettingOrSettingDefault<string>(worksheet, VIEW_ORDER_KEY);
}
